import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "./_guards/auth.guard";
import { Role } from "./_models/role";
import { MasterLayoutComponent } from "./mnt-master/master-layout/master-layout.component"


const routes: Routes = [
  {
    path: "login",
    loadChildren: "app/mnt-login/mnt-login.module#MntLoginModule"
  },
  {
    path: "invoice/:token",
    loadChildren: "app/mnt-public-order/mnt-public-order.module#MntPublicOrderModule"
  },
  {
    path: "signup",
    loadChildren: "app/mnt-subscriber/mnt-subscriber.module#MntSubscriberModule"
  },
  {
    path: "activation",
    loadChildren: "app/mnt-subscriber/mnt-subscriber.module#MntSubscriberModule"
  },
  {
    path: "store",
    loadChildren: "app/mnt-store-product/mnt-store-product.module#MntStoreProductModule"
  },
  {
    path: "builder",
    loadChildren: "app/mnt-public-quote/mnt-public-quote.module#MntPublicQuoteModule"
  },
  {
    path: "",
    redirectTo: "/login",
    pathMatch: "full"
  },
  {
    path: "",
    component: MasterLayoutComponent,
    children: [{
      path: "users",
      loadChildren: "app/mnt-users/mnt-users.module#MntUsersModule"
    },
    {
      path: "create-task",
      loadChildren: "app/mnt-task/mnt-task.module#MntTaskModule"
    },
    {
      path: "stores",
      loadChildren: "app/mnt-stores/mnt-stores.module#MntStoresModule"
    },
    {
      path: "settings",
      loadChildren: "app/mnt-settings/mnt-settings.module#MntSettingsModule"
    },
    {
      path: "matrix",
      loadChildren: "app/mnt-settings/mnt-settings.module#MntSettingsModule"
    },
    {
      path: "quotes",
      canActivate: [AuthGuard],
      data: { roles: [Role.Shop] },
      loadChildren: "app/mnt-quotes/mnt-quotes.module#MntQuotesModule"
    },
    {
      path: "products",
      canActivate: [AuthGuard],
      data: { roles: [Role.Shop] },
      loadChildren: "app/mnt-products/mnt-products.module#MntProductsModule"
    },
    {
      path: "invoices",
      canActivate: [AuthGuard],
      data: { roles: [Role.Shop, Role.Printer, Role.Designer] },
      loadChildren: "app/mnt-invoices/mnt-invoices.module#MntInvoicesModule"
    },
    {
      path: "dashboard",
      canActivate: [AuthGuard],
      data: { roles: [Role.Shop, Role.Printer, Role.Designer] },
      loadChildren: "app/mnt-dashboard/mnt-dashboard.module#MntDashboardModule"
    },
    {
      path: "admin",
      canActivate: [AuthGuard],
      data: { roles: [Role.Admin] },
      loadChildren: "app/mnt-admin/mnt-admin.module#MntAdminModule"
    },
    {
      path: "reports",
      canActivate: [AuthGuard],
      data: { roles: [Role.Shop] },
      loadChildren: "app/mnt-reports/mnt-reports.module#MntReportsModule"
    },
    {
      path: "quote",
      canActivate: [AuthGuard],
      data: { roles: [Role.Shop] },
      loadChildren: "app/mnt-invoices/mnt-invoices.module#MntInvoicesModule"
    },
    {
      path: "staff",
      loadChildren: "app/mnt-users/mnt-users.module#MntUsersModule"
    },
    {
      path: "commissions",
      loadChildren: "app/mnt-users/mnt-users.module#MntUsersModule"
    },
    {
      path: "designer",
      loadChildren: "app/mnt-users/mnt-users.module#MntUsersModule"
    },
    {
      path: "clients",
      loadChildren: "app/mnt-users/mnt-users.module#MntUsersModule"
    },
    {
      path: "search",
      loadChildren: "app/mnt-search/mnt-search.module#MntSearchModule"
    },
    {
      path: "po",
      canActivate: [AuthGuard],
      data: { roles: [Role.Shop] },
      loadChildren: "app/mnt-invoices/mnt-invoices.module#MntInvoicesModule"
    },
    ]
  },
  {
    path: "**",
    redirectTo: "/login",
    pathMatch: "full"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/app-routing.module.ts